function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.213%",
  y1: ".078%",
  x2: "50.213%",
  y2: "100.078%",
  id: "giftcard_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F69321",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F27D17",
  offset: "7%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED680D",
  offset: "17%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA5906",
  offset: "28%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95001",
  offset: "40%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84D00",
  offset: "59%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C43C00",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "33.027%",
  x2: "100%",
  y2: "100%",
  id: "giftcard_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.837%",
  y1: "32.575%",
  x2: "100%",
  y2: "89.272%",
  id: "giftcard_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.637 0h15.932c.904 0 1.636.733 1.636 1.637v10.33c0 .904-.732 1.637-1.636 1.637H1.637A1.637 1.637 0 010 11.967V1.637C0 .733.733 0 1.637 0z",
  fill: "url(#giftcard_svg__a)",
  fillRule: "nonzero",
  transform: "translate(1.222 4.889)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.199 6.09)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#giftcard_svg__b)",
  width: 4.988,
  height: 4.988,
  rx: 0.655
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.057 3.566a.255.255 0 01-.262-.248V1.513c0-.137.118-.248.262-.248.145 0 .263.111.263.248v1.805c0 .137-.118.248-.263.248M1.976 2.632a.255.255 0 01-.262-.247c0-.137.118-.248.262-.248.363 0 .658-.278.658-.62 0-.137.117-.248.262-.248.145 0 .262.111.262.248 0 .615-.53 1.115-1.182 1.115",
  fill: "#FDB913"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.896 3.566a.255.255 0 01-.262-.248v-.065c0-.342-.295-.62-.658-.62-.651 0-1.18-.5-1.18-1.116v-.004c0-.137.117-.248.261-.248.145 0 .263.111.263.248v.004c0 .342.294.62.656.62.652 0 1.182.5 1.182 1.116v.065a.255.255 0 01-.262.248",
  fill: "#F58220"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.057 1.76a.255.255 0 01-.262-.247c0-.615.53-1.115 1.182-1.115.144 0 .262.11.262.247a.255.255 0 01-.262.248c-.363 0-.657.278-.657.62 0 .137-.118.248-.263.248",
  fill: "#FDB913"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.896 1.765a.255.255 0 01-.262-.248c0-.342-.295-.62-.658-.62a.255.255 0 01-.262-.248c0-.137.118-.247.262-.247.652 0 1.182.5 1.182 1.115 0 .137-.117.248-.262.248",
  fill: "#F58220"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.428 12.598v1.129H7.172v4.766H6.056v-4.766H1.222v-1.13h4.834V4.89h1.116v7.709h13.256z",
  fill: "#FFF79F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.561 5.572a1.572 1.572 0 011.11 2.68c-.152.153-.452.37-1.3.528l1.114 1.115-.708.708L5.292 9.12l-1.484 1.484-.708-.708L4.215 8.78c-.848-.158-1.149-.375-1.302-.528a1.56 1.56 0 01-.46-1.11c0-.42.164-.814.46-1.11a1.56 1.56 0 011.11-.46c.42 0 .814.163 1.11.46.057.056.11.125.16.208l.05-.078a.97.97 0 01.108-.13 1.56 1.56 0 011.11-.46zM4.024 6.573a.565.565 0 00-.569.569c0 .152.06.294.167.402.11.108.571.23 1.1.305-.094-.635-.22-1.022-.298-1.111a.563.563 0 00-.4-.165zm2.537 0l-.09.007a.564.564 0 00-.312.16c-.076.087-.202.475-.297 1.11l.157-.025c.461-.075.845-.184.944-.281a.57.57 0 00-.402-.97z",
  fill: "url(#giftcard_svg__c)",
  transform: "translate(1.222 4.889)"
}));

function SvgGiftcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGiftcard;